export default {
	WishlistOverview: 'WishlistOverview'
};
